export default __webpack_public_path__ + "static/media/logotop.44aadeb4.svg";